/**
 * Text-to-3D generation (Tripo / prior Sloyd). Off by default until paid plans launch.
 * Set REACT_APP_AI_TEXT_TO_3D_ENABLED=true in `.env` to re-enable new generations.
 */
export const isAiTextTo3dEnabled = () =>
  process.env.REACT_APP_AI_TEXT_TO_3D_ENABLED === "true";

export const AI_TEXT_TO_3D_UNAVAILABLE_TITLE = "Coming soon on paid plans";

export const AI_TEXT_TO_3D_UNAVAILABLE_BODY =
  "AI model generation will be available on paid plans.";

export const AI_TEXT_TO_3D_WATERMARK = "Coming soon to paid plans";
